export function makeColumnDefs () {
  console.log('makeColumnDefs')

  const columnDefs = []

  columnDefs.push({
    headerName: 'Entity',
    field: 'name'
  })

  columnDefs.push({
    headerName: 'Disassociate',
    cellRenderer: function (cellParams) {
      return '<button class="button is-warning is-small is-flex" data-action="disassociate" data-entity-id="' + cellParams.data.id + '">Disassociate</button>'
    },
    cellClass: ['is-flex', 'is-align-items-center'] // vertical align
  })

  columnDefs.push({
    headerName: 'Xero Connection',
    cellRenderer: function (cellParams) {
      return `<div class="level">
        <button class="button is-info is-small is-flex" data-action="test-xero-connection" data-entity-id="${cellParams.data.id}">Test</button>
        <div d-type="feedback" data-entity-id="${cellParams.data.id}"></div>
      </div>`
    },
    cellClass: ['is-flex', 'is-align-items-center'] // vertical align
  })

  return columnDefs
}
